import { useEffect, useRef, useState } from "react";
import { safeFetch } from "@/api/safeFetch";
import { ButtonSiguiente } from "@/components/ui";
import { UsuarioDetalle } from "@/types";

interface DeshabilitarUsuarioAdminProps {
  usuario: UsuarioDetalle;
  onDone: () => void;
}

const DeshabilitarUsuarioAdmin: React.FC<DeshabilitarUsuarioAdminProps> = ({
  usuario,
  onDone,
}) => {
  const [motivo, setMotivo] = useState("");
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const token = localStorage.getItem("token") ?? "";

  const controllerRef = useRef<AbortController | null>(null);

  const deshabilitar = async () => {
    const ok = window.confirm(
      `⚠️ Vas a DESHABILITAR al usuario @${usuario.nombre_usuario}.`
    );
    if (!ok) return;
  
    controllerRef.current = new AbortController();
  
    setWorking(true);
    setError(null);
  
    try {
      const res = await safeFetch(
        `/api/admin/usuarios/${usuario.usuario_id}/deshabilitar`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ motivo }),
          signal: controllerRef.current.signal,
        }
      );
  
      if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json.message || "Error al deshabilitar usuario");
      }
  
      alert("🚫 Usuario deshabilitado correctamente");
      onDone();
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setError(err.message);
      }
    } finally {
      setWorking(false);
    }
  };
  
  // Limpieza REAL en un hook
  useEffect(() => {
    return () => {
      controllerRef.current?.abort();
    };
  }, []);  
  
  
  useEffect(() => {
    return () => {
      setMotivo("");
      setWorking(false);
      setError(null);
    };
  }, []);
  

  return (
    <div className="bg-white p-4 rounded shadow space-y-4">
      <h3 className="font-bold text-lg text-red-700">
        🚫 Deshabilitar usuario
      </h3>

      <p>
        <b>Usuario:</b> @{usuario.nombre_usuario}
      </p>
      <p>
        <b>Email:</b> {usuario.email}
      </p>

      <textarea
        className="w-full border rounded p-2 text-sm bg-zinc-200"
        placeholder="Motivo del bloqueo (opcional)"
        value={motivo}
        onChange={(e) => setMotivo(e.target.value)}
      />

      {error && <p className="text-red-600 font-semibold">{error}</p>}

      <div className="flex gap-3">
        <ButtonSiguiente
          onClick={onDone}
          className="flex-1 bg-gray-300 hover:bg-gray-400"
        >
          Cancelar
        </ButtonSiguiente>

        <ButtonSiguiente
          onClick={deshabilitar}
          disabled={working}
          className="flex-1 bg-red-600 hover:bg-red-700 text-white"
        >
          {working ? "Procesando…" : "🚫 Deshabilitar"}
        </ButtonSiguiente>
      </div>
    </div>
  );
};

export default DeshabilitarUsuarioAdmin;
